export const NAME = 'app';

export const MOBILE_CONSTRAINTS = {
    inlineSize: 896,
};
